import Vue from 'vue';
import OnlineNoticeDialog from './index.vue';
import Login from '@/utils/login';
import ROLE from '@/utils/roles';
export default class {
  constructor(options) {
    this.options = options;
    this.initDialog();
  }
  async initDialog() {
    this.status = await Login.getStatusData(ROLE.STUDENT, true);
    const DialogConstructor = Vue.extend(OnlineNoticeDialog);
    this.instance = new DialogConstructor();
    this.vm = this.instance.$mount();
    this.$el = this.vm.$el;
    this.dom = this.$el;
    document.body.appendChild(this.$el);
  }
  /**
   * @function hide 隐藏线上通知弹窗
   */
  hide() {
    this.vm.handleClose();
  }
  /**
   * @function show 显示线上通知弹窗
   * @param {Boolean} hasClose 是否有关闭按钮
   * @param {Boolean} hasBtn 是否有我已知悉按钮
   */
  show(hasClose = true, hasBtn = true) {
    this.vm.hasClose = hasClose;
    this.vm.hasBtn = hasBtn;
    this.vm.handleOpen();
  }
}
